import { T_SUBSCRIPTION_CARD_PAGE_CONSTANTS } from './TYPES'

const FR_SUBSCRIPTION_CARD_PAGE_CONSTANTS: T_SUBSCRIPTION_CARD_PAGE_CONSTANTS =
  {
    CHAMPION: {
      TITLE: 'Champion',
      DESCRIPTION: 'Meilleur choix pour {{minUser}}+ utilisateurs',
      TENURE_LABEL_TEXT: 'Choisissez la durée',
      TENURES_MAP: {
        6: '6 mois',
        12: '1 an',
        LIFETIME: 'À vie'
      },
      YOU_WILL_PAY_TEXT: 'VOUS ALLEZ PAYER',
      YOU_WILL_PAY_USER_TEXT: 'utilisateur',
      BUY_CTA_TEXT: 'Acheter le plan'
    },
    PREMIUM: {
      TITLE: 'Premium',
      DESCRIPTION: 'Meilleur choix pour {{minUser}}+ utilisateurs',
      TENURE_LABEL_TEXT: 'Choisissez la durée',
      TENURES_MAP: {
        6: '6 mois',
        12: '1 an',
        LIFETIME: 'À vie'
      },
      YOU_WILL_PAY_TEXT: 'VOUS ALLEZ PAYER',
      YOU_WILL_PAY_USER_TEXT: 'utilisateur',
      BUY_CTA_TEXT: 'Acheter le plan'
    },
    ADVENTURE: {
      TITLE: 'Aventure',
      DESCRIPTION: 'Meilleur choix pour les individus',
      TENURE_LABEL_TEXT: 'Choisissez la durée',
      TENURES_MAP: {
        6: '6 mois',
        12: '1 an',
        LIFETIME: 'À vie'
      },
      YOU_WILL_PAY_TEXT: 'VOUS ALLEZ PAYER',
      YOU_WILL_PAY_USER_TEXT: 'utilisateur',
      BUY_CTA_TEXT: 'Acheter le plan'
    }
  }

export default FR_SUBSCRIPTION_CARD_PAGE_CONSTANTS
